import type { App } from "vue";

import { Button, Field, Input, Select, Notification, Modal, Snackbar, Checkbox, Radio, Switch, Loading, Autocomplete, Tabs, Collapse, Icon, Progress } from "buefy";
import humanize from "humanize-plus";
import { format as formatDate } from "date-fns";
import deLocale from "date-fns/locale/de";

import { SvgIcon } from "~/common/svg-icon";

export function configureApp(app: App) {
	app.component("svg-icon", SvgIcon);

	app.use(Field);
	app.use(Input);
	app.use(Switch);
	app.use(Checkbox);
	app.use(Radio);
	app.use(Button);
	app.use(Select);
	app.use(Loading);
	app.use(Notification);
	app.use(Modal);
	app.use(Snackbar);
	app.use(Autocomplete);
	app.use(Tabs);
	app.use(Collapse);
	app.use(Icon);
	app.use(Progress);

	app.config.globalProperties.$formatters = {
		humanizeFilesize: (valueInBytes: number) => humanize.fileSize(valueInBytes),
		date: (value: string, format: string) => formatDate(value, format, { locale: deLocale })
	};
}
